const cardsHelp =  {
     "cardHeading": "Let me know how I can help",
     "cardItems": [
       {
         "title": "Billing",
         "icon": "Billing",
         "intent": "skill.billing.bill"
       },
       {
         "title": "TV troubleshooting",
         "icon": "TV",
         "intent": "tv"
       },
       {
         "title": "Xfinity Voice",
         "icon": "Voice",
         "intent": "voice"
       },
       {
         "title": "Internet troubleshooting",
         "icon": "Internet",
         "intent": "internet"
       },
       {
         "title": "Xfinity Home Security",
         "icon": "Home",
         "intent": "home"
       },
       {
         "title": "Xfinity ID or Password",
         "icon": "ForgotUserNamePassword",
         "intent": "login_and_password"
       },
       {
         "title": "Xfinity Apps",
         "icon": "AppSupport",
         "intent": "apps"
       },
       {
         "title": "Xfinity Mobile",
         "icon": "XfinityMobile",
         "intent": "mobile"
       },
       {
         "title": "TV remote pairing",
         "icon": "RemotePairing",
         "intent": "tv-remote"
       }
     ]
   }

export default cardsHelp;